.cardIdp {
    cursor: pointer;
}

.icon {
    width: 48px;
    height: 48px;
    border-radius: var(--exo-radius-standard);
    border: 1px solid var(--exo-color-border-secondary);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.info {
    display: flex;
    flex-flow: column nowrap;
    gap: var(--exo-spacing-standard);
}

.header {
    display: flex;
    flex-flow: row nowrap;
    gap: var(--exo-spacing-standard);
}

.content {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(3, auto);
    gap: var(--exo-spacing-x-small);
    justify-items: start;
}

.name,
.clientId,
.clientIdLabel {
    font: var(--exo-text-body-standard);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.name {
    font-weight: var(--exo-font-weight-semi-bold);
}

.clientId {
    max-width: 100%;
    font-weight: var(--exo-font-weight-semi-bold);
    color: var(--exo-color-font-secondary);
}

.clientIdLabel {
    font-weight: var(--exo-font-weight-semi-bold);
    margin-top: var(--exo-spacing-large);
}
